export enum PERMISSIONS_ENUM {
  // Dashboard
  SHOP_ADMIN_DASHBOARD_ACCESS = 'SHOP_ADMIN_DASHBOARD_ACCESS',

  // Promotion Programs
  SHOP_ADMIN_PROMOTION_ADD = 'SHOP_ADMIN_PROMOTION_ADD',
  SHOP_ADMIN_PROMOTION_EDIT = 'SHOP_ADMIN_PROMOTION_EDIT',
  SHOP_ADMIN_PROMOTION_ACCESS = 'SHOP_ADMIN_PROMOTION_ACCESS',
  SHOP_ADMIN_PROMOTION_DELETE = 'SHOP_ADMIN_PROMOTION_DELETE',
  SHOP_ADMIN_PROMOTION_APPROVE = 'SHOP_ADMIN_PROMOTION_APPROVE',
  SHOP_ADMIN_PROMOTION_VIEW_DETAIL = 'SHOP_ADMIN_PROMOTION_VIEW_DETAIL',
  SHOP_ADMIN_PROMOTION_TOGGLE_STATUS = 'SHOP_ADMIN_PROMOTION_TOGGLE_STATUS',

  // Voucher Management
  SHOP_VOUCHER_MANAGEMENT_ADD = 'SHOP_VOUCHER_MANAGEMENT_ADD',
  SHOP_VOUCHER_MANAGEMENT_EDIT = 'SHOP_VOUCHER_MANAGEMENT_EDIT',
  SHOP_VOUCHER_MANAGEMENT_DELETE = 'SHOP_VOUCHER_MANAGEMENT_DELETE',
  SHOP_VOUCHER_MANAGEMENT_ACCESS = 'SHOP_VOUCHER_MANAGEMENT_ACCESS',
  SHOP_VOUCHER_MANAGEMENT_APPROVE = 'SHOP_VOUCHER_MANAGEMENT_APPROVE',
  SHOP_VOUCHER_MANAGEMENT_VIEW_DETAIL = 'SHOP_VOUCHER_MANAGEMENT_VIEW_DETAIL',
  SHOP_VOUCHER_MANAGEMENT_TOGGLE_STATUS = 'SHOP_VOUCHER_MANAGEMENT_TOGGLE_STATUS',

  // Order Management
  SHOP_ORDER_MANAGEMENT_ACCESS = 'SHOP_ORDER_MANAGEMENT_ACCESS',
  SHOP_ORDER_MANAGEMENT_EXPORT = 'SHOP_ORDER_MANAGEMENT_EXPORT',
  SHOP_ORDER_MANAGEMENT_CANCEL = 'SHOP_ORDER_MANAGEMENT_CANCEL',
  SHOP_ORDER_MANAGEMENT_CONFIRM = 'SHOP_ORDER_MANAGEMENT_CONFIRM',
  SHOP_ORDER_MANAGEMENT_VIEW = 'SHOP_ORDER_MANAGEMENT_VIEW',
  SHOP_ORDER_MANAGEMENT_VIEW_DETAIL = 'SHOP_ORDER_MANAGEMENT_VIEW_DETAIL',

  // Shop Management
  SHOP_MANAGEMENT_EXPORT = 'SHOP_MANAGEMENT_EXPORT',
  SHOP_MANAGEMENT_ACCESS = 'SHOP_MANAGEMENT_ACCESS',
  SHOP_MANAGEMENT_EDIT_SHOP = 'SHOP_MANAGEMENT_EDIT_SHOP',
  SHOP_MANAGEMENT_EDIT_BAGDE = 'SHOP_MANAGEMENT_EDIT_BAGDE',
  SHOP_MANAGEMENT_EXPORT_LEGAL = 'SHOP_MANAGEMENT_EXPORT_LEGAL',
  SHOP_MANAGEMENT_TOGGLE_STATUS = 'SHOP_MANAGEMENT_TOGGLE_STATUS',
  SHOP_MANAGEMENT_VIEW_DASHBOARD = 'SHOP_MANAGEMENT_VIEW_DASHBOARD',

  // Product Management
  SHOP_PRODUCT_MANAGEMENT_BLOCK = 'SHOP_PRODUCT_MANAGEMENT_BLOCK',
  SHOP_PRODUCT_MANAGEMENT_ACCESS = 'SHOP_PRODUCT_MANAGEMENT_ACCESS',
  SHOP_PRODUCT_MANAGEMENT_DELETE = 'SHOP_PRODUCT_MANAGEMENT_DELETE',
  SHOP_PRODUCT_MANAGEMENT_VIEW_DETAIL = 'SHOP_PRODUCT_MANAGEMENT_VIEW_DETAIL',
  SHOP_PRODUCT_MANAGEMENT_EXPORT_PRODUCT_LIST = 'SHOP_PRODUCT_MANAGEMENT_EXPORT_PRODUCT_LIST',

  // Refund Management
  SHOP_REFUND_MANAGEMENT_REJECT = 'SHOP_REFUND_MANAGEMENT_REJECT',
  SHOP_REFUND_MANAGEMENT_ACCESS = 'SHOP_REFUND_MANAGEMENT_ACCESS',
  SHOP_REFUND_MANAGEMENT_APPROVE = 'SHOP_REFUND_MANAGEMENT_APPROVE',
  SHOP_REFUND_MANAGEMENT_VIEW_DETAIL = 'SHOP_REFUND_MANAGEMENT_VIEW_DETAIL',
  SHOP_REFUND_MANAGEMENT_RESUBMIT_REFUND = 'SHOP_REFUND_MANAGEMENT_RESUBMIT_REFUND',

  // Banner Management
  BANNER_SHOP_ACCESS = 'BANNER_SHOP_ACCESS',
  BANNER_SHOP_VIEW = 'BANNER_SHOP_VIEW',
  BANNER_SHOP_ADD = 'BANNER_SHOP_ADD',
  BANNER_SHOP_EDIT = 'BANNER_SHOP_EDIT',
  BANNER_SHOP_DELETE = 'BANNER_SHOP_DELETE',
  BANNER_SHOP_STATUS = 'BANNER_SHOP_STATUS',

  // FAQ Assistant
  CHAT_FAQ_ADD = 'CHAT_FAQ_ADD',
  CHAT_FAQ_EDIT = 'CHAT_FAQ_EDIT',
  CHAT_FAQ_VIEW = 'CHAT_FAQ_VIEW',
  CHAT_FAQ_DELETE = 'CHAT_FAQ_DELETE',
  CHAT_FAQ_ACCESS = 'CHAT_FAQ_ACCESS',

  // Soctrip Chat
  CHAT_SUPPORT_ACCESS = 'CHAT_SUPPORT_ACCESS',
  CHAT_SUPPORT_VIEW_CHAT = 'CHAT_SUPPORT_VIEW_CHAT',
  CHAT_SUPPORT_VIEW_HISTORY = 'CHAT_SUPPORT_VIEW_HISTORY',
  CHAT_SUPPORT_DELETE_HISTORY = 'CHAT_SUPPORT_DELETE_HISTORY',
  CHAT_SUPPORT_BASIC_CHAT_ACTION = 'CHAT_SUPPORT_BASIC_CHAT_ACTION',
  CHAT_SUPPORT_SETTING_VIEW = 'CHAT_SUPPORT_SETTING_VIEW',
  CHAT_SUPPORT_SETTING_EDIT = 'CHAT_SUPPORT_SETTING_EDIT',

  // Suppliers
  SHOP_SUPPLIER_MANAGEMENT_ACCESS = 'SHOP_SUPPLIER_MANAGEMENT_ACCESS',
  SHOP_SUPPLIER_MANAGEMENT_VIEW_DETAIL = 'SHOP_SUPPLIER_MANAGEMENT_VIEW_DETAIL',
  SHOP_SUPPLIER_MANAGEMENT_ADD = 'SHOP_SUPPLIER_MANAGEMENT_ADD',
  SHOP_SUPPLIER_MANAGEMENT_EDIT = 'SHOP_SUPPLIER_MANAGEMENT_EDIT',
  SHOP_SUPPLIER_MANAGEMENT_DELETE = 'SHOP_SUPPLIER_MANAGEMENT_DELETE',

  // Connect Sellers
  SHOP_CONNECT_SELLER_MANAGEMENT_ACCESS = 'SHOP_CONNECT_SELLER_MANAGEMENT_ACCESS',
  SHOP_CONNECT_SELLER_MANAGEMENT_VIEW_DETAIL = 'SHOP_CONNECT_SELLER_MANAGEMENT_VIEW_DETAIL',
  SHOP_CONNECT_SELLER_MANAGEMENT_ADD = 'SHOP_CONNECT_SELLER_MANAGEMENT_ADD',
  SHOP_CONNECT_SELLER_MANAGEMENT_EDIT = 'SHOP_CONNECT_SELLER_MANAGEMENT_EDIT',
  SHOP_CONNECT_SELLER_MANAGEMENT_DELETE = 'SHOP_CONNECT_SELLER_MANAGEMENT_DELETE',
  SHOP_SALE_CAMPAIGN_MANAGEMENT_VIEW_DETAIL = 'SHOP_SALE_CAMPAIGN_MANAGEMENT_VIEW_DETAIL',
  SHOP_SALE_CAMPAIGN_MANAGEMENT_EDIT = 'SHOP_SALE_CAMPAIGN_MANAGEMENT_EDIT',

  // Promote Sections
  SHOP_PROMOTE_SECTION_ACCESS = 'SHOP_PROMOTE_SECTION_ACCESS',
  SHOP_PROMOTE_SECTION_ADD_TAB = 'SHOP_PROMOTE_SECTION_ADD_TAB',
  SHOP_PROMOTE_SECTION_TOGGLE_STATUS = 'SHOP_PROMOTE_SECTION_TOGGLE_STATUS',
  SHOP_PROMOTE_SECTION_EDIT_TAB = 'SHOP_PROMOTE_SECTION_EDIT_TAB',
  SHOP_PROMOTE_SECTION_ORDER_ARRANGE = 'SHOP_PROMOTE_SECTION_ORDER_ARRANGE',
  SHOP_PROMOTE_SECTION_ADD_PRODUCT = 'SHOP_PROMOTE_SECTION_ADD_PRODUCT',
  SHOP_PROMOTE_SECTION_DELETE_PRODUCT = 'SHOP_PROMOTE_SECTION_DELETE_PRODUCT',
  SHOP_PROMOTE_SECTION_DELETE_TAB = 'SHOP_PROMOTE_SECTION_DELETE_TAB',

  // REFUND_MANAGEMENT - Module
  FLIGHT_REFUND_MANAGEMENT_ACCESS = 'FLIGHT_REFUND_MANAGEMENT_ACCESS',
  FLIGHT_REFUND_MANAGEMENT_VIEW_DETAIL = 'FLIGHT_REFUND_MANAGEMENT_VIEW_DETAIL',
  FLIGHT_REFUND_MANAGEMENT_REJECT = 'FLIGHT_REFUND_MANAGEMENT_REJECT',
  FLIGHT_REFUND_MANAGEMENT_APPROVE = 'FLIGHT_REFUND_MANAGEMENT_APPROVE',
  FLIGHT_REFUND_MANAGEMENT_RESUBMIT_REFUND = 'FLIGHT_REFUND_MANAGEMENT_RESUBMIT_REFUND',

  HOTEL_REFUND_MANAGEMENT_ACCESS = 'HOTEL_REFUND_MANAGEMENT_ACCESS',
  HOTEL_REFUND_MANAGEMENT_VIEW_DETAIL = 'HOTEL_REFUND_MANAGEMENT_VIEW_DETAIL',
  HOTEL_REFUND_MANAGEMENT_REJECT = 'HOTEL_REFUND_MANAGEMENT_REJECT',
  HOTEL_REFUND_MANAGEMENT_APPROVE = 'HOTEL_REFUND_MANAGEMENT_APPROVE',
  HOTEL_REFUND_MANAGEMENT_RESUBMIT_REFUND = 'HOTEL_REFUND_MANAGEMENT_RESUBMIT_REFUND',

  CAR_REFUND_MANAGEMENT_ACCESS = 'CAR_REFUND_MANAGEMENT_ACCESS',
  CAR_REFUND_MANAGEMENT_VIEW_DETAIL = 'CAR_REFUND_MANAGEMENT_VIEW_DETAIL',
  CAR_REFUND_MANAGEMENT_REJECT = 'CAR_REFUND_MANAGEMENT_REJECT',
  CAR_REFUND_MANAGEMENT_APPROVE = 'CAR_REFUND_MANAGEMENT_APPROVE',
  CAR_REFUND_MANAGEMENT_RESUBMIT_REFUND = 'CAR_REFUND_MANAGEMENT_RESUBMIT_REFUND',

  TRAVEL_REFUND_MANAGEMENT_ACCESS = 'TRAVEL_REFUND_MANAGEMENT_ACCESS',
  TRAVEL_REFUND_MANAGEMENT_VIEW_DETAIL = 'TRAVEL_REFUND_MANAGEMENT_VIEW_DETAIL',
  TRAVEL_REFUND_MANAGEMENT_REJECT = 'TRAVEL_REFUND_MANAGEMENT_REJECT',
  TRAVEL_REFUND_MANAGEMENT_APPROVE = 'TRAVEL_REFUND_MANAGEMENT_APPROVE',
  TRAVEL_REFUND_MANAGEMENT_RESUBMIT_REFUND = 'TRAVEL_REFUND_MANAGEMENT_RESUBMIT_REFUND',
}

export const MODERATOR_TYPE = [
  {
    title: 'Travel Administration',
    module: 'TOUR',
    permission: 'TOUR_MODULE_ADMIN',
    visible: true,
  },
  {
    title: 'Shop Administration',
    module: 'SHOP',
    permission: 'SHOP_MODULE_ADMIN',
    visible: true,
  },
  {
    title: 'Foods Administration',
    module: 'RESTAURANT',
    permission: 'FOOD_MODULE_ADMIN',
    visible: true,
  },
  {
    title: 'Car Rental Administration',
    module: 'CAR_RENTAL',
    permission: 'CAR_MODULE_ADMIN',
    visible: true,
  },
  {
    title: 'Hotel Administration',
    module: 'HOTEL',
    permission: 'HOTEL_MODULE_ADMIN',
    visible: true,
  },
  {
    title: 'Flight Administration',
    module: 'FLIGHT',
    permission: 'FLIGHT_MODULE_ADMIN',
    visible: true,
  },
];
